function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import ListenersMixin from '../../mixins/listeners.js';
import debounce from '../../utils/debounce.js';
import { height } from '../../utils/dom.js';
import { getScrollTarget, getScrollHeight, getScrollPosition, setScrollPosition } from '../../utils/scroll.js';
import { listenOpts } from '../../utils/event.js';
import { slot, uniqueSlot } from '../../utils/slot.js';
var passive = listenOpts.passive;
export default Vue.extend({
  name: 'QInfiniteScroll',
  mixins: [ListenersMixin],
  props: {
    offset: {
      type: Number,
      "default": 500
    },
    debounce: {
      type: [String, Number],
      "default": 100
    },
    scrollTarget: {
      "default": void 0
    },
    initialIndex: Number,
    disable: Boolean,
    reverse: Boolean
  },
  data: function data() {
    return {
      index: this.initialIndex || 0,
      isFetching: false,
      isWorking: true
    };
  },
  watch: {
    disable: function disable(val) {
      if (val === true) {
        this.stop();
      } else {
        this.resume();
      }
    },
    reverse: function reverse() {
      if (this.isFetching === false && this.isWorking === true) {
        this.immediatePoll();
      }
    },
    scrollTarget: function scrollTarget() {
      this.updateScrollTarget();
    },
    debounce: function debounce(val) {
      this.__setDebounce(val);
    }
  },
  methods: {
    poll: function poll() {
      if (this.disable === true || this.isFetching === true || this.isWorking === false) {
        return;
      }

      var scrollHeight = getScrollHeight(this.__scrollTarget),
          scrollPosition = getScrollPosition(this.__scrollTarget),
          containerHeight = height(this.__scrollTarget);

      if (this.reverse === false) {
        if (Math.round(scrollPosition + containerHeight + this.offset) >= Math.round(scrollHeight)) {
          this.trigger();
        }
      } else if (Math.round(scrollPosition) < this.offset) {
        this.trigger();
      }
    },
    trigger: function trigger() {
      var _this = this;

      if (this.disable === true || this.isFetching === true || this.isWorking === false) {
        return;
      }

      this.index++;
      this.isFetching = true;
      var heightBefore = getScrollHeight(this.__scrollTarget);
      this.$emit('load', this.index, function (stop) {
        if (_this.isWorking === true) {
          _this.isFetching = false;

          _this.$nextTick(function () {
            if (_this.reverse === true) {
              var heightAfter = getScrollHeight(_this.__scrollTarget),
                  scrollPosition = getScrollPosition(_this.__scrollTarget),
                  heightDifference = heightAfter - heightBefore;
              setScrollPosition(_this.__scrollTarget, scrollPosition + heightDifference);
            }

            if (stop === true) {
              _this.stop();
            } else {
              _this.$el.closest('body') && _this.poll();
            }
          });
        }
      });
    },
    reset: function reset() {
      this.index = 0;
    },
    resume: function resume() {
      if (this.isWorking === false) {
        this.isWorking = true;

        this.__scrollTarget.addEventListener('scroll', this.poll, passive);
      }

      this.immediatePoll();
    },
    stop: function stop() {
      if (this.isWorking === true) {
        this.isWorking = false;
        this.isFetching = false;

        this.__scrollTarget.removeEventListener('scroll', this.poll, passive);

        typeof this.poll.cancel === 'function' && this.poll.cancel();
      }
    },
    updateScrollTarget: function updateScrollTarget() {
      if (this.__scrollTarget && this.isWorking === true) {
        this.__scrollTarget.removeEventListener('scroll', this.poll, passive);
      }

      this.__scrollTarget = getScrollTarget(this.$el, this.scrollTarget);

      if (this.isWorking === true) {
        this.__scrollTarget.addEventListener('scroll', this.poll, passive);

        if (this.reverse === true) {
          var scrollHeight = getScrollHeight(this.__scrollTarget),
              containerHeight = height(this.__scrollTarget);
          setScrollPosition(this.__scrollTarget, scrollHeight - containerHeight);
        }

        this.immediatePoll();
      }
    },
    setIndex: function setIndex(index) {
      this.index = index;
    },
    __setDebounce: function __setDebounce(val) {
      val = parseInt(val, 10);
      var oldPoll = this.poll;
      this.poll = val <= 0 ? this.immediatePoll : debounce(this.immediatePoll, isNaN(val) === true ? 100 : val);

      if (this.__scrollTarget && this.isWorking === true) {
        if (oldPoll !== void 0) {
          this.__scrollTarget.removeEventListener('scroll', oldPoll, passive);
        }

        this.__scrollTarget.addEventListener('scroll', this.poll, passive);
      }
    }
  },
  mounted: function mounted() {
    this.immediatePoll = this.poll;

    this.__setDebounce(this.debounce);

    this.updateScrollTarget();
  },
  activated: function activated() {
    if (this.__scrollPosition !== void 0 && this.__scrollTarget) {
      setScrollPosition(this.__scrollTarget, this.__scrollPosition);
    }
  },
  deactivated: function deactivated() {
    this.__scrollPosition = this.__scrollTarget ? getScrollPosition(this.__scrollTarget) : void 0;
  },
  beforeDestroy: function beforeDestroy() {
    this.stop();
  },
  render: function render(h) {
    var child = uniqueSlot(this, 'default', []);

    if (this.disable !== true && this.isWorking === true) {
      child[this.reverse === false ? 'push' : 'unshift'](h('div', {
        staticClass: 'q-infinite-scroll__loading',
        "class": this.isFetching === true ? '' : 'invisible'
      }, slot(this, 'loading')));
    }

    return h('div', {
      staticClass: 'q-infinite-scroll',
      on: _objectSpread({}, this.qListeners)
    }, child);
  }
});